import { render, staticRenderFns } from "./full-dim-popup.vue?vue&type=template&id=7cfd98fd&scoped=true&"
import script from "./full-dim-popup.vue?vue&type=script&lang=js&"
export * from "./full-dim-popup.vue?vue&type=script&lang=js&"
import style0 from "./full-dim-popup.vue?vue&type=style&index=0&id=7cfd98fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd98fd",
  null
  
)

export default component.exports